import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ThreeDot } from "react-loading-indicators";
import { StreamChat } from "stream-chat";
import {
  Chat,
  Channel,
  ChannelList,
  Window,
  ChannelHeader,
  MessageList,
  MessageInput,
  Thread,
  Avatar,
} from "stream-chat-react";
import "stream-chat-react/css/v2/index.css";

const STREAM_API_KEY = "fbmvyqg55v45";
const STREAM_TOKEN = localStorage.getItem("stream_token");
const USER_ID = localStorage.getItem("stream_user_name");

export default function App() {
  const [chatClient, setChatClient] = useState(null);
  const [activeChannel, setActiveChannel] = useState(null);
  const { i18n } = useTranslation();
  const currentLang = i18n.language;

  useEffect(() => {
    const initChat = async () => {
      const client = StreamChat.getInstance(STREAM_API_KEY);
      await client.connectUser({ id: USER_ID, name: USER_ID }, STREAM_TOKEN);
      setChatClient(client);
    };
    initChat();
    return () => chatClient?.disconnectUser();
  }, []);

  if (!chatClient)
    return (
        <div className="flex justify-center items-center h-[25rem]"><ThreeDot variant="bounce" color="#D06421" size="large" text="" textColor="" /></div> 
    );
  const CustomChannelPreview = ({ channel, setActiveChannel, activeChannel }) => {
    const lastMessage = channel.state.messages?.at(-1)?.text || "لا توجد رسائل بعد";
    const members = Object.values(channel.state.members);
    const receiver = members.find((m) => m.user.id !== USER_ID);
    const receiverName = receiver?.user?.name || "مستخدم غير معروف";
    const image = receiver?.user?.image || channel.data?.image || "/default-avatar.png";
    const lastAt = channel.data?.last_message_at;
    const time = lastAt
      ? new Date(lastAt).toLocaleTimeString("ar-SY", { hour: "2-digit", minute: "2-digit" })
      : "";

    const isActive = activeChannel?.id === channel.id;

    return (
      <div
        onClick={() => setActiveChannel(channel)}
        className={`flex items-center gap-3 px-4 py-3 border-b border-black cursor-pointer transition-all ${
          isActive
            ? "bg-thirdly text-white"
            : "hover:bg-thirdly text-gray-800"
        }`}
      >
        <Avatar image={image} name={receiverName} size={40} />
        <div className="flex flex-col w-full">
          <div className="font-medium text-sm text-white truncate">{receiverName}</div>
          <div className="text-xs flex justify-between items-center mt-1 text-gray-400 font-medium">
            <p className="truncate max-w-[120px]">{lastMessage}</p>
            <p>{time}</p>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="py-2 px-4">
      <Chat client={chatClient} theme="str-chat__theme-dark">
        <div className="flex h-[84vh] bg-gray-50 rounded-md overflow-hidden">
          {/* Sidebar */}
          <aside className="w-72 flex flex-col shadow-md">
            <div className="py-[18px] text-center text-white font-semibold bg-black sticky top-0">
              {currentLang == "ar" ? " المحادثات" : "Conversations" }
            </div>
            <div className="flex-1 overflow-y-auto scrollable">
              <ChannelList
                filters={{ type: "messaging", members: { $in: [USER_ID] } }}
                sort={{ last_message_at: -1 }}
                options={{ watch: true, state: true }}
                Preview={(props) => (
                  <CustomChannelPreview
                    {...props}
                    activeChannel={activeChannel}
                    setActiveChannel={setActiveChannel}
                  />
                )}
              />
            </div>
          </aside>

          {/* Chat Window */}
          <div className="flex flex-1 flex-col">
            {activeChannel ? (
              <Channel channel={activeChannel}>
                <Window>
                  <ChannelHeader />
                  {/* <div className="flex-1 overflow-y-auto scrollable"> */}
                    <MessageList />
                  {/* </div> */}
                  <MessageInput focus placeholder="اكتب رسالتك هنا..." />
                </Window>
                <Thread />
              </Channel>
            ) : (
              <div className="flex-1 flex items-center justify-center w- bg-black">
                <h3 className="text-white">{currentLang == "ar" ? " 👈 اختر محادثة لبدء الدردشة" : "Choose A Chat To Start Chating" }</h3>
              </div>
            )}
          </div>
        </div>
      </Chat>
    </div>
  );
}
